/*
 * @Descripttion: 请求服务
 * @Author: Scarlett Xiao
 * @Date: 2021-12-21 15:58:24
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-05-31 14:41:42
 */
import axios from "axios";
// import Cookies from "js-cookie";
import * as cookieServ from '@/utils/methods/cookie';
import * as domainServ from '@/utils/methods/domain';
import store from "../store/index"
import {
  Loading,
  Message
} from 'element-ui';
let isMobile = false;
const baseUrl = /Android |webos | iphone| iPod| BlackBerry| liPad/i.test(navigator.userAgent) ?
  (isMobile = true, '/ufish_admin/app') :
  (isMobile = false, '/ufish_admin/pc');
axios.defaults.timeout = 500000 // 请求超时
axios.defaults.baseURL = baseUrl;
axios.defaults.withCredentials = true;


// request拦截器
axios.interceptors.request.use(
  config => {
    // 后端接口认证信息
    config.headers["Token"] = isMobile ? store.state.app.token : cookieServ.getCookie('token'); // Cookies.get("token");
    config.headers["lang"] = "zh_CN";
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    return config;
  },
  error => {
    console.log('异常请求');
    // console.error(error);
  }
);

// respone拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code !== "0000") {
      Message.error(response.data.msg);
      if (response.data.code === '9999') {
        sessionStorage.clear();
        setTimeout(() => {
          // token 过期，返回平台登录
          window.location.replace(domainServ.getHost());

          // 重新登录
          // router.push({
          //   name: "/login"
          // });
        }, 300);
      }
    }
    return response;
  },
  error => {
    console.log('异常请求');
    // console.error(error);

  }
);


const http = {

  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @returns Promise
   */
  get(url) {
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   * @returns Promise
   */
  post(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },
  // 文件下载
  postDownload(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          responseType: "blob" // 设置responseType对象格式为 blob:
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    })
  },
  // 文件上传
  postUpload(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: {
            "content-type": "multipart/form-data"
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    })
  },

  /**
   * put方法，对应put请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   * @returns Promise
   */
  put(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, params)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  /**
   * 删除方法，对应delete请求
   * @param {String} url [请求的url地址]
   * @returns Promise
   */
  delete(url) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },
}

export default http;